import { GearSixIcon, SignOutIcon } from "@phosphor-icons/react"
import { Button } from "@repo/ui/components/button"
import { useNavigate } from "react-router"

import { PagePlaceholder } from "@/components/page-placeholder"
import { signOut, useSession } from "@/lib/auth-client"

export function SettingsPage() {
  const navigate = useNavigate()
  const { data: session } = useSession()

  return (
    <>
      <PagePlaceholder
        title="Settings"
        description="Your preferences will show up here."
        icon={GearSixIcon}
      />
      <div className="flex flex-col items-center gap-3 px-6 pb-6">
        {session && (
          <p className="text-xs text-muted-foreground">
            Signed in as {session.user.email}
          </p>
        )}
        <Button
          variant="outline"
          size="lg"
          onClick={async () => {
            await signOut()
            await navigate("/login", { replace: true })
          }}
        >
          <SignOutIcon aria-hidden />
          Sign out
        </Button>
      </div>
    </>
  )
}
